import { Link } from 'react-router-dom'
import { ArrowLeft, BookOpen } from 'lucide-react'
import MainLayout from '../components/Layout/MainLayout'
import { ACCOUNT_PAGES_HERO_IMAGE_URL } from '../constants/accountPagesHeroImage'
import {
  RESERVE_WELCOME_PACK_PATH,
  RESERVE_WELCOME_PACK_DEFAULT_TOPIC_ID,
} from '../constants/reserveWelcomePack'

const firstWelcomePackTopicPath = `${RESERVE_WELCOME_PACK_PATH}/${RESERVE_WELCOME_PACK_DEFAULT_TOPIC_ID}`

const ReserveMembershipGuidePage = () => {
  return (
    <MainLayout>
      <div className="min-h-screen min-w-0 w-full overflow-x-clip bg-neutral-100">
        <section className="relative h-72 sm:h-80 bg-black overflow-hidden">
          <div className="h-12" />
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-55"
            style={{ backgroundImage: `url("${ACCOUNT_PAGES_HERO_IMAGE_URL}")` }}
            aria-hidden
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/15 to-black/40" />
          <div className="relative z-10 flex h-full flex-col justify-center px-4 sm:px-6 lg:px-8">
            <div className="mx-auto w-full max-w-4xl">
              <Link
                to="/profile"
                className="mb-6 inline-flex items-center gap-2 text-sm font-medium text-slate-300 transition-colors hover:text-white"
              >
                <ArrowLeft className="h-4 w-4" aria-hidden />
                Back to Reserve membership
              </Link>
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white/10">
                  <BookOpen className="h-6 w-6 text-white" aria-hidden />
                </div>
                <div>
                  <h1 className="typography-hero-title-on-dark mb-2 text-3xl font-bold text-white sm:text-4xl">
                    Guide to your Reserve membership
                  </h1>
                  <p className="max-w-2xl text-base text-slate-300 sm:text-lg">
                    Learn how Axonall Reserve works, what is included, and how to get the most from your
                    membership.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <main className="mx-auto flex max-w-3xl flex-col items-center px-4 pb-20 pt-10 text-center sm:px-6 sm:pt-12 sm:pb-24 lg:pb-28">
          <h2 className="font-AXONALLPrimeSemiBold m-0 text-center text-[clamp(0.8125rem,2vw+0.42rem,2.125rem)] font-bold leading-[1.15] tracking-tight text-black">
            <span className="block whitespace-nowrap">Your welcome pack is ready.</span>
            <span className="mt-0.5 block whitespace-nowrap sm:mt-1">Are you ready to begin?</span>
          </h2>

          <Link
            to={firstWelcomePackTopicPath}
            className="font-poppinsSemiBold mt-10 inline-flex items-center justify-center border border-neutral-950 bg-neutral-950 px-8 py-3.5 text-center text-xs uppercase tracking-[0.14em] text-white transition hover:bg-black sm:mt-12 sm:px-10 sm:py-4 sm:text-[13px]"
          >
            Open welcome pack
          </Link>

          <p className="font-poppinsLight mt-8 max-w-md text-sm leading-relaxed text-neutral-500">
            Prefer to browse from the start? You&apos;ll land on the first topic—you can use the
            handbook menu to jump anywhere.
          </p>

          <Link
            to={RESERVE_WELCOME_PACK_PATH}
            className="font-poppinsMedium mt-3 text-sm text-neutral-700 underline-offset-4 transition hover:text-black hover:underline"
          >
            Or open the welcome pack home
          </Link>
        </main>
      </div>
    </MainLayout>
  )
}

export default ReserveMembershipGuidePage
